import React from "react";
import { withTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { EnquiryIdContainer, IDButton } from "../EnquiryId/EnquiryId.styled";
import { GrayPara } from "../../EnquiryList.styled";
import { DivBackgroundOpacity } from "@utils/extra-style";

const SiteTender = (props) => {
  const { t, data } = props;

  const typeText = {
    0: "SITE_TYPE_LIVE",
    1: "SITE_TYPE_TENDER",
  };

  return (
    <>
      <DivBackgroundOpacity opacity={data.isActive ? 1 : "0.2"}>
        <span>{t(typeText[data.isTender])}</span>
      </DivBackgroundOpacity>
    </>
  );
};

SiteTender.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(SiteTender);
